import { render, staticRenderFns } from "./ProductCharacteristics.vue?vue&type=template&id=3c7c3870&scoped=true"
import script from "./ProductCharacteristics.vue?vue&type=script&lang=ts"
export * from "./ProductCharacteristics.vue?vue&type=script&lang=ts"
import style0 from "./ProductCharacteristics.vue?vue&type=style&index=0&id=3c7c3870&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7c3870",
  null
  
)

export default component.exports